
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

const HomeHero = () => {
  const phrases = [
    "Deep Research",
    "Customer Support", 
    "Coding Agents",
    "Content Creation",
    "Copilot Agents",
  ];
  const [currentPhraseIndex, setCurrentPhraseIndex] = useState(0);
  const [isFading, setIsFading] = useState(false);

  useEffect(() => {
    const intervalId = setInterval(() => {
      setIsFading(true);

      setTimeout(() => {
        setCurrentPhraseIndex((prev) => (prev + 1) % phrases.length);
        setIsFading(false);
      }, 500);
    }, 3000);

    return () => clearInterval(intervalId);
  }, [phrases.length]);

  return (
    <section className="pt-6 md:pt-12 pb-8 relative">
      <div className="flex flex-col items-center text-center space-y-4">
        <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-foreground tracking-tight leading-tight font-mono text-center">
          RL for
        </h1>
        <div className="w-full flex justify-center items-center">
          <span
            className={`inline-block transition-opacity duration-500 text-[#ff5733] text-center text-3xl md:text-4xl lg:text-5xl font-bold font-mono ${
              isFading ? "opacity-0" : "opacity-100"
            }`}
            style={{ minWidth: "10em", textAlign: "center" }}
          >
            {phrases[currentPhraseIndex]}
          </span>
        </div>
        <p className="text-lg text-muted-foreground max-w-3xl font-mono">
          Optimize any agent with Reinforcement Learning. Use OpenPipe's RL
          platform to make your agent <strong>reliable</strong>,{" "}
          <strong>scalable</strong>, and <strong>compliant</strong>.
        </p>

        <div className="flex flex-col sm:flex-row w-full max-w-md justify-center gap-4 mt-6">
          <a
            href="https://github.com/OpenPipe/ART"
            target="_blank"
            rel="noopener noreferrer"
            className="w-auto"
          >
            <button className="px-6 py-3 bg-primary text-primary-foreground rounded-lg font-medium hover:bg-primary/90 transition-colors w-auto">
              Use open source
            </button>
          </a>
          <Link to="/book-demo" className="w-auto">
            <button className="px-6 py-3 bg-secondary text-foreground rounded-lg font-medium hover:bg-secondary/80 transition-colors w-auto">
              Book a demo
            </button>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default HomeHero;

